@if(content) {
<div class="hide-print"
     [elementHeight]="'full-header'"
     [elementHeightOptions]="{topOffset: true}">
    <sticky-free class="notification-bar-wrapper"
                 [order]="0"
                 [style.z-index]="11"
                 [stickyOff]="app.client.isCms"
                 *ifNotCheckoutProcess>
        <page-component-notification-bar #notificationBar
                                         #cmsNodes />
    </sticky-free>

    <ng-container *ifNotCheckoutProcess>
        <div class="page-header__wrapper"
             [pageHeaderBody]
             #cmsNodes>
            <sticky-free class="pos-relative"
                         [order]="1"
                         [stickyId]="'page-header'"
                         [style.z-index]="999">
                <header class="w-12 page-header"
                        [attr.id]="headerId"
                        [toggleClass]="'is-meganav-open'"
                        [toggleClassBy]="meganavToggleGroupId"
                        [class.is-cms]="client.isCms">
                    @if (content) {
                    <div class="page-header__inner flex flex-middle z-2"
                         [ngClass]="model?.data?.styles?.background_color || 'bg-col-w'"
                         [style.min-height.px]="54"
                         [elementHeight]="'header'"
                         [elementHeightOptions]="{topOffset: false, local: false}">
                        <ng-container *ifSize="'XL'">
                            <search-modal *afterContentInit
                                          class="z-10 bg-col-w pos-absolute top-0 left-0 search-modal" />
                        </ng-container>
                        <div class="wrap flex-s flex-m flex-middle pos-relative">
                            <!-- menu / S, M -->
                            <div class="flex-span-1"
                                 *ifSize="'MS'">
                                <!-- menu toggle -->
                                <button class="page-header__icon off-canvas-menu-open"
                                        type="button"
                                        aria-label="Menu"
                                        (click)="openOffCanvas()">
                                    <i class="icon-menu"
                                       aria-hidden="true"></i>
                                </button>
                                <!-- search -->
                                <button class="page-header__icon m-l-4 m-l-2-s"
                                        type="button"
                                        aria-label="Search"
                                        cy-searchBtn
                                        [iCmsModalOpen]="'offCanvas_search_tray'">
                                    <i class="icon-search2"
                                       [style.font-size.px]="36"
                                       aria-hidden="true"></i>
                                </button>
                            </div>
                            <tag [tag]="imageTag"
                                 *ifSize="'MS'">
                                <a class="flex flex-middle inline-block page-header__logo"
                                   routerLink="/">
                                    <img [image]="content.logo_image"
                                         [options]="{fitIn: true}"
                                         [attr.alt]="content.logo_alt">
                                </a>
                            </tag>
                            <div class="flex flex-justify-between"
                                 *ifSize="'XL'">
                                <div class="flex flex-middle p-r-3">
                                    <tag [tag]="imageTag">
                                        <a class="inline-block page-header__logo"
                                           routerLink="/">
                                            <img [image]="content.logo_image"
                                                 [options]="{fitIn: true}"
                                                 [attr.alt]="content.logo_alt">
                                        </a>
                                    </tag>
                                </div>

                                <!-- meganav -->
                                @for (menuTab of menuTabs; track menuTab; let i = $index) {
                                <ng-container *abIf="menuTab.abIfExp">
                                    <meganav class="block p-t p-b-5 center meganav-hide"
                                             [class.ng-hide]="!isActiveTab(menuTab)"
                                             [style.margin-right]="client.isX || client.isL ? 'auto' : 'unset'"
                                             [items]="menuTab.menu"
                                             [tabIndex]="i"
                                             #cmsNodes />
                                </ng-container>
                                }

                                <!-- header icons-->
                                <div class="flex flex-middle meganav-hide">
                                    <ng-container *ngTemplateOutlet="headerIcons" />
                                </div>
                            </div>
                            <div class="flex-span-1 right"
                                 *ifSize="'MS'">
                                <ng-container *abIf="'(headerIconsOrder) B'">
                                    <!-- contact us -->
                                    <a class="page-header__icon"
                                       routerLink="/contact-us"
                                       title="Contact us">
                                        <i class="icon-phone3"
                                           style="font-size: 36px"
                                           aria-hidden="true"></i>
                                    </a>
                                    <a *ifNotLoggedIn
                                       class="page-header__icon"
                                       routerLink="/login"
                                       routerLinkActive="is-active"
                                       cy-loginBtn
                                       title="Sign In">
                                        <i class="icon-account2 m-r-1 m-l-1"
                                           style="padding-right:2px;padding-left:2px;"
                                           [style.font-size.px]="24"
                                           aria-hidden="true"></i>
                                    </a>
                                </ng-container>
                                <!-- wishlist -->
                                <wishlist-qty *ifLoggedIn />
                                <!-- sign in -->
                                <ng-container *abIf="'(headerIconsOrder) A'">
                                    <a *ifNotLoggedIn
                                       class="page-header__icon m-l"
                                       routerLink="/login"
                                       routerLinkActive="is-active"
                                       cy-loginBtn
                                       title="Sign In">
                                        <i class="icon-account2 m-r-1 m-l-1"
                                           style="padding-right:2px;padding-left:2px;"
                                           [style.font-size.px]="24"
                                           aria-hidden="true"></i>
                                    </a>
                                </ng-container>
                                <!-- basket -->
                                <a routerLink="/basket"
                                   basketQtyBullet
                                   aria-label="Basket"
                                   class="page-header__icon inline-block m-l-2"><i class="icon-basket"
                                       [style.font-size.px]="24"
                                       aria-hidden="true"></i></a>
                            </div>
                            <!-- <search-modal *afterContentInit
       class="z-10 bg-col-w"></search-modal> -->
                        </div>
                    </div>
                    <!-- meganav content -->
                    <ng-container *afterContentInit>
                        <div class="pos-absolute right-0 left-0 pe-none"
                             *ifSize="'XL'">
                            @for (menuTab of menuTabs; track menuTab; let i = $index) {
                            <ng-container *abIf="menuTab.abIfExp">
                                <meganav-content class="block"
                                                 [class.ng-hide]="!isActiveTab(menuTab)"
                                                 [items]="menuTab.menu"
                                                 [tabIndex]="i"
                                                 #cmsNodes />
                            </ng-container>
                            }
                        </div>
                    </ng-container>
                    <!-- search content -->
                    <ng-container *ifSize="'XL'">
                        <search-outlet class="z-1"
                                       *afterContentInit
                                       [toggleClass]="'!ng-hide'"
                                       [toggleClassBy]="[undefined, 'header']"
                                       [searchId]="'header'"
                                       [hideOnLocationChange]="true"
                                       #cmsNodes />
                    </ng-container>
                    <!-- trust bar -->
                    <!-- <ng-include src="'/ui/page/trust-bar.html'"></ng-include> -->
                    }
                </header>
            </sticky-free>
        </div>


        <!-- meganav overlay -->
        <meganav-overlay />

        <!-- header icons template-->
        <ng-template #headerIcons>
            <!-- search -->

            <!-- clickEvent="search.focus" -->
            <!-- [iCmsModalOpen]="search-content-block" -->
            <span role="button"
                  class="page-header__icon cursor-pointer m-r-2"
                  [clickEvent]="'search.focus'"
                  aria-label="Search">
                <i class="icon-search2"
                   aria-hidden="true"
                   [style.font-size.px]="36"
                   cy-searchBtn></i>
            </span>

            <!-- contact us -->
            <a class="page-header__icon m-r-2"
               [ga4TrackClick]="{
           name: 'phone_icon_tracking',
           details: {
               phone_icon_device: 'Desktop'
           }
      }"
               routerLink="/contact-us"
               title="Contact us">
                <i class="icon-phone3"
                   [style.font-size.px]="36"
                   aria-hidden="true"></i>
            </a>

            <ng-container *ifLoggedIn>
                <!-- my account -->
                <a class="page-header__icon m-r-2"
                   routerLink="/account"
                   routerLinkActive="is-active"
                   cy-loginBtn
                   title="My Account">
                    <i class="icon-account2 m-l-1 m-r-1"
                       style="padding-right:2px;padding-left:2px;"
                       [style.font-size.px]="24"
                       aria-hidden="true"></i>
                </a>
            </ng-container>

            <ng-container *ifNotLoggedIn>
                <!-- sign in -->
                <a class="page-header__icon m-r-2"
                   routerLink="/login"
                   routerLinkActive="is-active"
                   cy-loginBtn
                   title="Sign In">
                    <i class="icon-account2 m-l-1 m-r-1"
                       style="padding-right:2px;padding-left:2px;"
                       [style.font-size.px]="24"
                       aria-hidden="true"></i>
                </a>
            </ng-container>

            <!-- wishlist -->
            <wishlist-qty />

            <!-- basket -->
            <button basketQtyBullet
                    aria-label="Basket"
                    [iCmsModalOpen]="minibasketModalId"
                    class="page-header__icon inline-block m-r-2-x m-l-3"
                    [ga4TrackClick]="{
               name: 'side_basket_open',
               details: {}
           }">
                <i class="icon-basket"
                   [style.font-size.px]="24"
                   aria-hidden="true"></i></button>
        </ng-template>
    </ng-container>

    <div class="w-12 page-header--checkout pos-relative bg-col-w flex flex-justify-center"
         *ifCheckoutProcess>
        <div class="wrap flex">

            <div class="flex flex-justify-center flex-middle w-12 pos-relative">
                <div class="pos-absolute top-0 bottom-0 left-0 flex flex-middle page-header--checkout-icon-container">
                    <i class="icon-lock page-header--checkout-icon"></i>
                    <p class="p1 page-header--checkout-icon-text"
                       *ifSize="'XL'">{{'Secure Checkout' | translate}}</p>
                </div>
                <!-- logo -->
                <a class="inline-block quarantine"
                   [routerLink]="logoURL">
                    <img [image]="content.logo_image"
                         [options]="{fitIn: true}"
                         [attr.height]="client.isX || client.isL ? 37 : 34"
                         [attr.width]="client.isX || client.isL ? 126 : 116"
                         [attr.alt]="content.logo_alt">
                </a>
            </div>
        </div>
    </div>
</div>
}
